import { useRef, FormEvent, useCallback } from 'react';
import { USER_SUBMITTED_OVERWHELMED_FORM } from './OverwhelmedForm';
import { useConfig, useLogger, useUniversalFetchingHelpers } from '@ids/appshell';
import { AddToIDSWaitlistModel, NowApiResponse } from '@ids/types/now-api';
import { useCookies } from '@ids/context/Cookies';

const useOverwhelmedForm = (callback?: () => void) => {
    const formRef = useRef<HTMLFormElement>(null);
    const { countryCode } = useConfig();
    const { post } = useUniversalFetchingHelpers();
    const [, setCookie] = useCookies([USER_SUBMITTED_OVERWHELMED_FORM], { path: '/', maxAge: 60 * 60 * 24 * 7 });
    const log = useLogger();

    const handleSubmit = useCallback(
        async (event: FormEvent<HTMLFormElement | HTMLButtonElement>) => {
            event.preventDefault();

            if (!formRef.current) {
                return;
            }

            setCookie(USER_SUBMITTED_OVERWHELMED_FORM, 'true');

            const formDataEntries = new FormData(formRef.current).entries();

            const { email } = Object.fromEntries(formDataEntries);

            if (email && typeof callback === 'function') {
                callback();
            }

            const idsWaitlistResponse = await post<NowApiResponse<AddToIDSWaitlistModel>>({
                path: '/web/v1/ids/waitlist',
                body: JSON.stringify({ email }),
            });

            if (!idsWaitlistResponse.success || !idsWaitlistResponse.data.success) {
                log.error(
                    idsWaitlistResponse.data.errorMessage ||
                        `IDS OverwhelmedForm - Add to waitlist error: ${email} was not properly saved to the db`
                );
            } else {
                log.info(`IDS OverwhelmedForm - ${email} was added to the waitlist on ${countryCode}`);
            }
        },
        [callback, countryCode, log, post, setCookie]
    );

    return { formRef, handleSubmit };
};

export default useOverwhelmedForm;
